// DenteX — the product identity, distinct from any clinic's identity.
//
// Two branding layers coexist deliberately:
//   PRODUCT  (this file)      — DenteX: fixed, compiled in, identical for the
//                               whole fleet. The software's own name.
//   CLINIC   (/clinic/branding + COMPANY_NAME env) — Navident, Smile, …: the
//                               tenant's identity, resolved at runtime.
//
// Surface rule of thumb: the product brands the TOOL (login hero, help center,
// favicon/PWA icons, tab-title suffix); the clinic brands the WORK (sidebar
// workspace, quotes, invoices, patient-facing everything).
export const PRODUCT_NAME = "DenteX";
export const PRODUCT_DESCRIPTOR = "Clinic Management Suite";
// The moto — owner copy, used verbatim. It is the login hero, where it
// replaced the "Care that runs like clockwork." tagline. PRODUCT_DESCRIPTOR is
// kept because the PWA manifest still names the product that way.
export const PRODUCT_MOTO = "All in one system for dental clinics";
// The brand blue, taken from the supplied artwork (DenteX-Logo.png /
// dentex-wordmark.png) and already baked into app/icon.svg. Every rendering of
// the mark starts here; dark surfaces lift it with brightness(1.45)
// saturate(1.15) rather than declaring a second colour, so the wordmark raster
// and the vector glyph cannot drift apart again.
export const PRODUCT_MARK_BLUE = "#1571A0";
